import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/LoginComponent';
import { LogoutComponent } from './logout/LogoutComponent';

const adminRoutes: Routes = [
	{
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'logout',
        component: LogoutComponent
    }
];

export const adminRouting: ModuleWithProviders = RouterModule.forChild(adminRoutes);


// WEBPACK FOOTER //
// ./src/common/modules/admin/AdminRouting.ts